import { render, staticRenderFns } from "./ChargeList.vue?vue&type=template&id=36804c35&"
import script from "./ChargeList.vue?vue&type=script&lang=js&"
export * from "./ChargeList.vue?vue&type=script&lang=js&"
import style0 from "./ChargeList.vue?vue&type=style&index=0&id=36804c35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports